<template>
  <div class="kit-tips card card-shrink" v-bind:class="'card table kit-type-id-' + result.kit_type_id + '-color'">
    <div class="back">
      <button @click="$emit('back')" class="button item-btn">
        <font-awesome-icon :icon="['fa', 'arrow-left']"/>
        Voltar
      </button>
      <button @click="$emit('changeView', 'rsl')" class="button btn-primary btn-min">Resultados</button>
      <button v-if="result.kit_type_id > 2" @click="$emit('changeView', 'rsk')" class="button btn-primary btn-min">Riscos de Saúde</button>
      <button v-if="result.kit_type_id > 2" @click="$emit('changeView', 'pln')" class="button btn-primary btn-min">Plano de cuidado</button>
      <button class="button btn-primary btn-min" @click="$emit('download', result.id, result.exam.lab_document_id)">Laudo</button>
    </div>
    <div class="tips-header">
      <div class="image-section-title">
        <span class="title">Dicas & Orientações para o empoderamento de sua saúde</span>
        <h1>{{result.kit_type.name}}</h1>
      </div>
    </div>
	<template v-if="result.kit_type_id <= 2">
		<return-modal :data="result" />
	</template>
	<template v-if="result.kit_type_id > 2">
    <div class="content">
		<div class="kit-explanation" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
				<p>Olá, {{result.customer.name}}!</p>
				<p>É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.</p>
				<p>O <span class="bold archivo">{{result.kit_type.name}}</span> lhe entrega muito mais que resultados, mas
				também dicas e orientações de como você pode seguir a sua vida, a fim de prevenir ou auxiliar no combate às
				cardiopatias.</p>
				<p>De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,
				montamos dicas e orientações para você e por você.</p>
				<p>Se você possui alguma cardiopatia, desconfia que tem alguma doença cardíaca ou se você tem histórico familiar
				da doença, orientamos sempre a necessidade de consultar um médico, pois a cardiopatia é mais fácil de ser
				tratada quando detectada precocemente.</p>
				<p>Vale lembrar que muitas formas de doenças cardíacas podem ser prevenidas com a adoção de um estilo de vida
				mais saudável e é para isso que estamos aqui!</p>
				<p>Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, quais
				sejam: <span class="bold"><a href="#alimentacao">alimentação</a>, <a href="#rotina">rotina</a> e <a href="#mente">mente.</a></span></p>
		</div>
      	<div class="kit-explanation" v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'">
			<p>Olá, {{result.customer.name}}!</p>
			<p>É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.</p>
			<p>O <span class="bold archivo">{{result.kit_type.name}}</span> lhe entrega, além de resultados, dicas e
			orientações de como você deve seguir a sua rotina, a fim de prevenir ou auxiliar no combate as principais
			doenças crônicas.</p>
			<p>De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,
			montamos dicas e orientações para você e por você.</p>
			<p>Se você possui alguma doença crônica, desconfia que tem ou se você tem histórico familiar de alguma doença,
			orientamos sempre a necessidade de consultar um médico, pois é mais fácil de ser tratada quando detectada
			precocemente.</p>
			<p>Vale lembrar que muitas formas de doenças crônicas são caracterizadas pela progressão lenta e de longa
			duração, podendo ser silenciosas ou sintomáticas. Entretanto, muitas destas doenças possuem tratamentos
			adequados que garantem melhoras significativas no bem-estar e qualidade de sua vida.</p>
			<p>Mudanças nos hábitos são necessárias tanto no controle como na prevenção das doenças crônicas. Os fatores de
			risco evitáveis têm um papel importante no surgimento e progressão destas doenças. Um estilo de vida saudável
			pode melhorar a expectativa e a qualidade de vida.</p>
			<p>Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, quais
			sejam: <span class="bold"><a href="#alimentacao">alimentação</a>, <a href="#rotina">rotina</a> e <a href="#mente">mente.</a></span></p>
      	</div>
		<div class="kit-explanation" v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'">
			<p>Olá, {{result.customer.name}}!</p>
			<p>É um prazer termos você como cliente para que possamos lhe ajudar no cuidado com a sua saúde.</p>
			<p>O <span class="bold archivo">{{result.kit_type.name}}</span> lhe entrega, além de resultados, dicas e
			orientações de como você deve seguir a sua rotina, a fim de lhe dar maior tranquilidade com relação à sua
			saúde e bem-estar.</p>
			<p>De acordo com as informações obtidas através das respostas do seu formulário e o resultado de seus exames,
			montamos dicas e orientações para você e por você.</p>
			<p>Queremos aqui lhe fornecer informações para que você realize as mudanças necessárias em seus hábitos de vida
			para auxiliar a ter um envelhecimento mais saudável.</p>
			<p>Seja o jovem do futuro e tenha saúde para viver muito mais.</p>
			<p>Como base essencial para o seu cuidado, foram traçados três pilares para um plano de cuidado eficiente, <span
			class="bold"><a href="#alimentacao">alimentação</a>, <a href="#rotina">rotina</a> e <a href="#mente">mente.</a></span></p>
		</div>
		<div class="section" id="alimentacao">
			<div class="section-title">
				<span class="upper">Cuidados com sua</span>
				<span class="lower">alimentação</span>
			</div>
		</div>
      	<div class="hashtag rotate" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
        	<span id="1">#Insira alimentos cardioprotetores na sua dieta!</span>
      	</div>
		<div class="section">
			<div class="section-title" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
				<span class="upper">Mas o que são alimento</span>
				<span class="lower">cardioprotetores?</span>
			</div>
			<div class="text" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
				<p>
					Você já deve ter ouvido falar dos alimentos cardioprotetores, aqueles que possuem ação sobre a diminuição da
					pressão arterial,
					do colesterol ruim, triglicérides e controle do peso. Também contribuem na melhora do colesterol bom e a
					diminuição da agregação plaquetária,
					que é responsável por controlar a boa circulação sanguínea para evitar coágulos e derrames.
				</p>
				<p>
					Os alimentos que pertencem a esse grupo são aqueles que protegem o coração, como vitaminas, minerais, fibras
					e antioxidantes,
					e que não apresentem nutrientes que podem prejudicar o coração, como gordura saturada, colesterol e sódio.
				</p>
			</div>
			<div class="text" v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'">
      <div class="image-veggies">
        <img alt="Mulher bebendo suco verde, sobre mesa com vegetais." src="@/assets/images/alimentacao_saudavel.jpg">
      </div>
			<p>
				As dietas alimentares predominantemente baseadas em vegetais reduzem o risco de desenvolver e/ou agravar
				obesidade,
				diabetes, hipertensão, dislipidemia, entre outras. Dietas a base de vegetais são ricas em hortaliças,
				frutas, grãos integrais,
				leguminosas, frutas secas e contém apenas pequenas porções de carne e laticínios. Estas dietas ajudam a
				atingir e manter um peso saudável,
				reduzem a pressão sanguínea e ainda são ricas em fontes de fibras alimentares (que protegem contra o câncer
				colorretal).
			</p>
			<p>
				As frutas e os vegetais contribuem para a prevenção de doenças cardiovasculares. É possível que determinados
				vegetais e frutas,
				incluindo vegetais crucíferos, como repolho e brócolis e muitas frutas ou vegetais ricas em ácido fólico,
				ainda protejam contra o
				desenvolvimento de câncer do cólon, retal, bucal, de faringe, de laringe e de esôfago.
			</p>
			<p>
				Comer carne vermelha e processada aumenta o risco de desenvolver câncer colorretal. Gorduras saturada e
				trans aumentam o colesterol no
				sangue e o risco cardiovascular. A alta ingestão de sódio/sal é um dos fatores de risco principais para
				pressão sanguínea elevada, doenças cardiovasculares e provavelmente câncer de estômago.
			</p>
			<p>
				Dietas ricas em carne e laticínios também aumentam a pressão sanguínea. As dietas ricas em alimentos ou
				bebidas de alta densidade energética,
				altamente processados e ricos em amidos ou açúcares refinados contribuem para o sobrepeso e a obesidade.
			</p>
      <p>
			  <span class="bold">Composição corporal</span>
      </p>
			<p>
				Sobrepeso e obesidade estão associados ao aumento da mortalidade e risco elevado de doença ou morte
				provocados por doenças cardiovasculares,
				diabetes e diversos tipos de câncer. Isto ocorre pelo aumento da pressão sanguínea e do colesterol no
				sangue, da resistência à insulina e de inflamação,
				assim como dos níveis hormonais.
			</p>
      <div class="image-healthy-food">
        <img alt="Alguns dos alimentos que contribuem para um organismo saudável." src="@/assets/images/alimentacao_saude.png">
      </div>
      <p>
			  <span class="bold">Particularidade para você que apresenta obesidade:</span>
      </p>
			<p>
				Os principais conselhos que podemos trazer para quem apresenta obesidade são:
			<ul class="ul">
				<li>Coma devagar, mastigando muito bem os alimentos e parar de comer com o estômago “meio vazio”;</li>
				<li>Use as gorduras na quantidade mínima para cozinhar e temperar como, por exemplo, algumas gotas de azeite
				no peixe cozido e nas hortaliças, e um pouco de manteiga nas torradas;
				</li>
				<li>Coma de todas as maneiras, isto é, não ingerir só grelhados e cozidos, mas, também, alimentar-se com
				assados e fritos, tendo o cuidado de lhes retirar a gordura;
				</li>
				<li>Não beba vinho nem outras bebidas alcoólicas. O álcool, além de ser um alimento muito rico em calorias,
				e que só por si engorda, tem, ainda, o inconveniente de abrir o apetite;
				</li>
				<li>Beba água, mas não exageradamente durante as refeições, a fim de se não distender o estômago e aumentar
				o apetite;
				</li>
				<li>Não coma pão nem ao almoço nem ao jantar e fora destas refeições comê-lo o menos possível, e torrado,
				para dificultar a mastigação;
				</li>
				<li>Não coma açúcar, mesmo que este seja só para adoçar o café e outras bebidas amargas (se o médico
				permitir pode usar-se sacarina). Não coma, também, doces e bolos que têm enormes quantidades de açúcar;
				</li>
				<li>Coma no mínimo cinco refeições por dia: café da manhã, almoço, lanche, jantar e antes de deitar;</li>
				<li>Evite os medicamentos para emagrecer. Use-os somente com orientação médica.</li>
			</ul>
			</p>
      <p>
			  <span class="bold">Particularidade para você que é diabético:</span>
      </p>
			<p>
				Os alimentos que devem ser evitados na dieta para diabéticos são aqueles ricos em açúcar ou carboidratos
				simples, como:
			<ul class="ul">
				<li>Açúcar e doces em geral;</li>
				<li>Mel, geleia de frutas, compotas, marmelada, produtos de confeitaria e pastelaria;</li>
				<li>Doces em geral, chocolates e guloseimas;</li>
				<li>Bebidas açucaradas, como refrigerantes, sucos industrializados e achocolatados;</li>
				<li>Tubérculos em geral, como batata, batata doce, macaxeira e inhame, pois têm elevada concentração de
				carboidratos e devem ser consumidos em pequenas porções;
				</li>
				<li>Carnes processadas, como presunto, peito de peru, salsicha, linguiça, bacon, mortadela e salame;</li>
				<li>Bebidas alcoólicas, como cervejas, vinhos e destilados.</li>
			</ul>
			</p>
      <p>
			  <span class="bold">Particularidade para você que é hipertenso:</span>
      </p>
			<p>
				Para melhor resultado no tratamento de hipertensão arterial é fundamental a adoção de um hábito alimentar
				saudável,
				além da realização de atividades físicas, redução do consumo de bebidas alcoólicas e cessação do hábito de
				fumar.
			</p>
			<p>
				As principais recomendações para casos de hipertensão são:
			<ul class="ul">
				<li>Procure usar o mínimo de sal no preparo dos alimentos (1 colher de chá considerando todas as
				refeições);
				</li>
				<li>Para não exagerar no sal, evite deixar o saleiro na mesa;</li>
				<li>Leia sempre o rótulo dos alimentos, verificando a quantidade de sódio;</li>
				<li>Prefira temperos naturais (cebola, alho, cheiro verde, limão, orégano…) e evite temperos prontos (caldo
				de carne, caldo de galinha, sopa industrializada);
				</li>
				<li>Procure evitar alimentos industrializados, como embutidos, enlatados e carnes salgadas. Além de conter
				muito sódio, eles também têm alto teor de gorduras;
				</li>
				<li>Diminua o consumo de gorduras, preferindo alimentos cozidos, assados ou grelhados;</li>
				<li>Evitar o consumo excessivo de bebidas alcoólicas e o tabagismo;</li>
				<li>Consumir, pelo menos, três porções de frutas e hortaliças por dia;</li>
			</ul>
			</p>
			</div>
        <div class="text" v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'">
          <div class="image-healthy-food">
            <img alt="Casal dançando sob luzes coloridas." src="@/assets/images/alimentacao_saude2.jpg">
          </div>
          <p>
            Coma diariamente verduras escuras, leites e seus derivados, ou seja, uma dieta que forneça os nutrientes
            essenciais e as
            quantidades adequadas de calorias, evitando o excesso de açúcar, carboidratos e alimentos gordurosos.
          </p>
          <p>
            Vamos passar 9 dicas para auxiliar na sua alimentação:
          </p>
          <p>
            <span class="bold">1º passo</span> - Faça três refeições ao dia (café da manhã, almoço e jantar) e, caso
            necessário, faça outras refeições nos intervalos.
          </p>
          <p>
            <span class="bold">2º passo</span> - Dê preferência aos grãos integrais e aos alimentos na sua forma mais
            natural.
          </p>
          <p>
            <span class="bold">3º passo</span> - Inclua frutas, legumes e verduras em todas as refeições ao longo do
            dia.
          </p>
          <p>
            <span class="bold">4º passo</span> - Coma feijão com arroz, de preferência no almoço ou no jantar.
          </p>
          <p>
            <span class="bold">5º passo</span> - Lembre-se de incluir carnes, aves, peixes, ovos, leite e derivados em
            pelo menos uma refeição durante o dia.
            Retirar a gordura aparente das carnes e a pele das aves antes da preparação torna esses alimentos mais
            saudáveis.
            Os leites e derivados são ricos em cálcio, que ajuda no fortalecimento dos ossos. Já as carnes, as aves, os
            peixes e os ovos são ricos
            em proteínas e minerais.
          </p>
          <p>
            <span class="bold">6º passo</span> - Use pouca quantidade de óleos, gorduras, açúcar e sal no preparo dos
            alimentos.
          </p>
          <p>
            <span class="bold">7º passo</span> - Beba água mesmo sem sentir sede, de preferência nos intervalos das
            refeições.
          </p>
          <p>
            <span class="bold">8º passo</span> - Evite bebidas açucaradas (refrigerantes, sucos e chás
            industrializados), bolos e biscoitos recheados, doces e outras guloseimas como regra da alimentação.
          </p>
          <p>
            <span class="bold">9º passo</span> - Fique atento às informações nutricionais dos rótulos dos produtos
            processados e ultraprocessados para favorecer a escolha de produtos alimentícios mais saudáveis.
          </p>
        </div>
      </div>
      <div class="section flex-start" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
        <div class="left-image">
          <span>Entre eles estão:</span>
          <div class="image">
            <img alt="Alguns dos alimentos que contribuem para um organismo saudável." src="@/assets/images/alimentacao_saude.png"/>
          </div>
        </div>
        <div class="items">
          <span>aveia,</span>
          <span>abacate,</span>
          <span>azeite,</span>
          <span>castanhas,</span>
          <span>grãos como feijões, linhaça, lentilha, grão-de-bico,</span>
          <span>frutas como morango, mirtilo, banana, tomate e framboesa,</span>
          <span>chocolate amargo,</span>
          <span>chá-verde</span>
        </div>
      </div>
      <div class="section" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
        <div class="middle">
          <div class="hashtag">
            <span id="1">#Não consuma álcool exageradamente</span>
          </div>
          <div class="text">
            <p style="max-width: 600px;">A ingestão exagerada de álcool pode causar infarto do miocárdio e insuficiência
              cardíaca,
              entre muitos outros problemas que não atacam diretamente o coração, mas interferem nos rins e outros
              órgãos.</p>
          </div>
          <div class="float-image">
            <img alt="Taça de vinho sendo derrubada." src="@/assets/images/taca.png" style="margin-left: 150px; margin-top: -35px;"/>
          </div>
        </div>
      </div>
      <div class="section flex-start" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
        <div class="image-shadow">
          <img alt="Homem correndo sob sombra da obesidade." src="@/assets/images/sombra.png">
        </div>
        <div class="text">
          <div class="hashtag">
            # Evite ingerir alimentos ricos em gordura e sal
          </div>
          <p>Alimentos gordurosos são prejudiciais para a nossa saúde e ainda mais para o coração.</p>
          <div class="hashtag">
            # Realize consultas periódicas
          </div>
          <p>O colesterol alto, diabetes e a pressão alta são preocupantes. Além de uma boa alimentação, consultas
            periódicas são muito
            importantes para controlar esses tipos de distúrbios, siga o plano de cuidado que realizamos especialmente
            para você.</p>
          <div class="hashtag">
            # Mantenha o peso ideal
          </div>
          <p>A obesidade é uma aliada para o surgimento de doenças vasculares, procure optar sempre por uma alimentação
            balanceada e rica em proteínas, além de praticar atividade física.</p>

        </div>
      </div>
      <div class="container-gambs">
        <div class="section" id="rotina">
          <div class="section-title">
            <span class="upper">Pratique</span>
            <span class="lower">atividade física</span>
          </div>
        </div>

        <div class="text" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
          <p>
            Todas as atividades aeróbicas em geral são adequadas para a melhoria da saúde, já que a grande vantagem
            desses exercícios é a
            elevação da capacidade cardiorrespiratória.
          </p>
          <p>
            A prática regular de atividades físicas ajuda na prevenção de doenças cardiovasculares, pois reduz a
            tensão arterial e o colesterol,
            aumenta a energia e melhora qualidade do sono, além de ajudar a manter o peso saudável e controlar o
            estresse.
          </p>
        </div>
        <div class="text" v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'">
          <div class="image-running">
            <img alt="Casal correndo em um gramado perto da água." src="@/assets/images/correndo.jpg">
          </div>
          <p>
            Os exercícios físicos são importantes para combater o sedentarismo e auxiliar no combate de doenças.
            Mas, devemos antes de tudo alertar você que comprou o kit de Doenças Crônicas, que a recomendação aqui
            é um pouco diferente daqueles indicados para o aperfeiçoamento do condicionamento físico, pois muito mais
            que estética estamos
            preocupados com a sua saúde.
          </p>
          <p>
            Em suma, não é seguro prescrevemos para você atividades físicas de alta intensidade, com cronograma
            especifico,
            sem antes compreender a existência e estágio da doença crônica. Busque auxilio junto aos profissionais da
            Educação Física e Fisioterapia,
            levando consigo tudo que você terá de informações aqui no Health Lab.
          </p>
          <p>
            <span class="bold">Mas então eu devo ficar parado até buscar auxílio?</span>
          </p>
          <p>
            Não! A grande maioria dos portadores de doenças crônicas temem que a prática de exercícios físicos possa
            agravar os males que sofrem.
            No entanto, as atividades físicas são benéficas e precisam fazer parte do dia a dia das pessoas.
          </p>
          <p>
            <span class="bold">Quais são as atividades físicas mais indicadas?</span>
          </p>
          <p>
            Dependendo do problema existem algumas restrições. No entanto, não é aconselhável o abandono total da
            prática do exercício físico.
          </p>
          <p>
            <span class="bold">Para quem apresenta obesidade</span>
          </p>
          <p>
            Para ir eliminando gordura é necessário melhorar a atividade cardiorrespiratória, tendo como alvo os
            exercícios aeróbicos
            (caminhada e bicicleta). Posteriormente e, não havendo restrições, implementar a musculação ou
            fisioterapia
            para melhorar os movimentos articulares.
          </p>
          <p>
            Lembre-se que para os casos de obesidade, o essencial é iniciar bem devagar, ou seja, uma atividade de
            baixo impacto
            (caminhada, bicicleta, natação e hidroginástica, por exemplo) com 10 minutos e depois ir aumentando
            periodicamente 5
            minutos até chegar ao máximo de 40 minutos diários.
          </p>
          <p>
            <span class="bold">Para quem é diabético:</span>
          </p>
          <p>
            Confira quais exercícios você pode fazer sem riscos:
          </p>
          <p>
            1° Caminhada - Elas aceleram o batimento cardíaco e o sistema respiratório, queimando calorias e
            consumindo glicose.
            Ao caminhar, o diabético deve optar por locais seguros e tranquilos como um parque e, se possível, estar
            sempre acompanhado de alguém.
          </p>
          <p>
            2° Bicicleta - Devido ao risco de quedas, é recomendável fazer o exercício em uma bicicleta ergométrica.
            Pedalar aumenta a frequência cardíaca e respiratória e queima gorduras. Além disso, causa um grande
            estímulo na circulação,
            sobretudo nas pernas, onde o risco é maior nos diabéticos.
          </p>
          <p>
            3° Natação e hidroginástica - Permitem uma ampla gama de atividades físicas mas atenuam todo impacto no
            corpo.
            A água dá uma sustentação maior para o corpo, diminuindo o peso nas juntas e articulações. Além disso a
            natação
            promove uma melhora na circulação de todo o corpo, fortalece a musculatura, queima gorduras e aumenta a
            captação da glicose pelos músculos.
          </p>
          <p>
            Lembrando que é sempre recomendável levar algum tipo de carboidrato para os momentos de exercícios,
            como castanhas e snacks integrais, para os casos de baixa glicêmica repentina.
            Água também é crucial nos momentos de atividade física e ainda mais para pessoas com diabetes,
            pois além de repor as perdas durante o exercício, a água ajuda a controlar os níveis de açúcar no sangue.
          </p>
          <p>
            <span class="bold">Para quem é hipertenso:</span>
          </p>
          <p>
            Uma das principais formas de prevenir e tratar a hipertensão arterial é praticando regularmente atividades
            físicas.
            O exercício provoca uma queda da pressão auxiliando no combate da doença, no entanto, alguns cuidados são
            necessários durante a
            atividade para garantir a sua segurança.
          </p>
          <p>
            É importante determinar o ritmo e a intensidade da atividade física, lembrando que se você não está
            habituado a fazer atividade
            física deve iniciar com caminhadas leves de 10 à 20 minutos por dia, com ritmo lento e sem paradas.
            Depois de adquirida uma certa segurança e confiança, o tempo pode ir aumentando periodicamente.
          </p>
          <p>
            Ressaltamos, ainda, que durante a prática da atividade física, o ideal é estar sempre com uma garrafa de
            água por perto,
            especialmente se for ao ar livre. Desidratação aumenta a chance de pico de pressão durante exercício!
          </p>
          <p>
            Depois da atividade física, podem aparecer dores musculares e cansaço. Este tipo de sintoma é considerado
            normal,
            já que o corpo não está acostumado. Essas sensações tendem a melhorar com o passar do tempo.
            Por outro lado, tontura, falta de ar intensa e aperto no peito podem indicar que há um problema mais sério
            e você deverá
            ir ao médico para consultar.
          </p>
        </div>
        <div class="text" v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'">
          <p>
            Vamos tentar melhorar a sua qualidade de vida construindo novos significados para que consiga ultrapassar
            qualquer barreira entre você e o seu corpo.
          </p>
          <p>
            Iremos lhe passar 5 meios para ajudar a aumentar a sua qualidade de vida, fazendo com que você fique mais
            saudável.
          </p>
          <div class="image-dancing">
            <img alt="Casal dançando sob luzes coloridas." src="@/assets/images/dancando.jpg">
          </div>
          <p>
            <span class="bold">1° Caminhada</span> - A caminhada ajuda a aumentar a densidade óssea, fazendo com que
            os ossos fiquem mais fortes.
            Além disso, este exercício melhora o equilíbrio e a coordenação motora, diminuindo o risco de quedas e,
            consequentemente,
            de fraturas. Faça caminhadas de no mínimo 20 minutos, diariamente.
          </p>
          <p>
            <span class="bold">2° Dança</span> - A dança trabalha diretamente sobre os ossos das pernas, quadril e
            coluna, ajudando a retardar a
            perda mineral óssea. Além disso, ela melhora a circulação sanguínea e o coração.
          </p>
          <p>
            <span class="bold">3° Subir escadas</span> - Subir escadas é também um ótimo exercício para você, sendo
            recomendado trocar todos os elevadores pelas escadas,
            desde que em andares mais baixos, principalmente na descida, porque o impacto é maior e, por isso, há
            maior estimulação da produção de massa óssea.
          </p>
          <p>
            <span class="bold">4° Jardinagem</span> - A jardinagem é também um ótimo exercício para você, desde que
            seja mantida a postura correta,
            porque implica fazer movimentos de impacto como cortar a grama ou usar a tesoura de poda para cortar as
            plantas, por exemplo,
            que ajudam a fortalecer os ossos. A jardinagem é um ótimo exercício para fortalecer os ossos dos braços.
          </p>
          <p>
            <span class="bold">5° Musculação</span> - A musculação exerce tensão nos músculos e ossos, ajudando a
            aumentar a densidade óssea e a fortalecer ossos, sendo o levantamento de pesos excelente para favorecer a
            formação de ossos fortes e sadios.
          </p>
          <p>
            Outros exercícios como a natação, a hidroginástica, o ciclismo, a ioga ou o tai chi chuan, melhoram a
            função cardiovascular,
            assim como a concentração, o equilíbrio e a força, ajudando a diminuir o risco à sua saúde.
          </p>
          <p>
            Por fim, mas não menos importante, lembre-se que antes de praticar qualquer exercício, é importante
            consultar o
            médico para avaliar a densidade óssea e adaptar os exercícios ao seu condicionamento físico e sua idade.
          </p>
        </div>

        <div class="section" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
          <div class="section-title">
            <span class="upper">Por quanto</span>
            <span class="lower">tempo?</span>
          </div>
          <div class="text">
            <p>
              São recomendados pelo menos 150 minutos por semana de atividade física moderada.
              É possível dividir em cinco sessões diárias de 30 minutos, por exemplo, ou 50 minutos por três vezes por
              semana.
              Já para quem pratica musculação, a recomendação é de dois a três treinos, em dias alternados.
            <p>
            <p>
              O estilo de vida sedentário está associado ao risco maior de doença coronariana, por isso a prática de
              atividade física
              é uma das maiores aliadas da saúde de todos os corações.
            </p>
          </div>
        </div>
        <div class="section" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
          <div class="section-title">
            <span class="upper">Qual</span>
            <span class="lower">intensidade?</span>
          </div>
          <div class="text">
            <p>
              É importante que o exercício seja prescrito pelo médico de forma individualizada, assim como é feito com a
              indicação de medicamentos.
              Orientações de frequência, tempo adequado, intensidade e progressão levam em conta fatores de risco e o
              histórico clínico do paciente,
              complementando exame físico completo e uso de medicações. Em alguns casos pode ser necessário iniciar a
              atividade física em um ambiente
              supervisionado, inclusive com monitor cardíaco.
            </p>
          </div>
        </div>
      </div>
      <div class="section" id="mente">
        <div class="centralized">
          <div class="section-title">
            <span class="upper">Sua</span>
            <span class="lower">mente</span>
          </div>
          <div class="text" v-if="result.kit_type.tag_type === 'check-up-saude-do-coracao'">
            <p>
              Fortes emoções podem gerar palpitações no peito, falta de ar e outros sintomas que, em geral, associamos
              às doenças cardíacas.
              De fato, o coração é afetado pelo que pensamos e sentimos. E quando o coração vai mal, ele também pode
              afetar nosso estado de espírito.
            </p>
            <p>
              Por isso, os sintomas emocionais manifestados por pessoas que têm cardiopatias nunca devem ser ignorados
              por familiares ou amigos próximos.
              Paralelamente, quem é deprimido também tem mais chances de desenvolver doenças do coração.
            </p>
            <p>
              Pressão no peito, sensação de bola na garganta, falta de ar e palpitações são alguns dos sintomas físicos
              que podem estar associados a
              problemas emocionais. Isso é consequência da conexão entre corpo e mente, gerada principalmente pelo
              sistema nervoso autônomo - a parte do sistema
              nervoso responsável por coordenar o funcionamento dos órgãos internos do corpo, como estômago, genitais e
              coração.
            </p>
            <p>
              Assim, quando recebemos uma ótima notícia ou ficamos emocionados, nosso coração acelera. Da mesma forma,
              quando somos surpreendidos por algo negativo,
              podemos sentir palpitações. Estas reações do organismo são normais e todo mundo as sente. Porém, quando as
              emoções negativas se perpetuam, provocando
              descargas contínuas de cortisol e outros hormônios, o corpo pode sofrer as consequências. Sono, apetite e
              humor podem ficar prejudicados,
              gerando distúrbios emocionais e cardiopatias relacionadas.
            </p>
            <p>
              Sabemos hoje da importância de mantermos nossos pensamentos e sentimentos equilibrados para se ter saúde
              física.
            </p>
            <p>
              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para
              você, sua saúde lhe agradecerá.
            </p>
          </div>
          <div class="text" v-if="result.kit_type.tag_type === 'check-up-doencas-cronicas'">
            <p>
              A menos que você tenha vivido sob uma rocha na última década, provavelmente já ouviu falar sobre os muitos
              benefícios que a meditação
              alegou oferecer: tudo, desde diminuição da ansiedade e depressão até menos estresse, melhor sono e até
              redução da perda de memória.
              Mas muitas pessoas estão começando a recorrer à meditação para ajudar a controlar as doenças crônicas.
              Isso é bom demais para ser verdade,
              ou algo que vale a pena adicionar ao seu regime de autocuidado? Vamos olhar para a ciência e descobrir.
            </p>
            <p>
              A meditação o ajudará a relaxar e a lidar com os estressores cotidianos da vida! Para as pessoas o
              estresse de lidar com uma doença
              crônica pode ser monumental. Pesquisas mostram que a meditação regular reduz a resposta ao estresse do
              corpo, diminuindo a pressão arterial,
              diminuindo a frequência cardíaca, reduzindo a ingestão de oxigênio e até mesmo modifica as ondas cerebrais
              para um modo mais relaxado.
            </p>
            <p>
              A meditação também pode ajudar com o controle de impulsos e ajudar a fazer escolhas mais conscientes
              quando se trata de exercícios e
              alimentação saudável, o que pode ter enormes benefícios em seus níveis de glicose no sangue, que cria um
              ciclo de escolhas saudáveis
              ​​que levam a um controle ainda melhor.
            </p>
            <p>
              A importância de uma prática regular de meditação não deve ser ignorada quando se contempla o cuidado com
              as doenças crônicas.
              Discuta as possibilidades de meditação com seu médico, e talvez essa importante ferramenta possa se tornar
              parte de seu gerenciamento e
              sucesso em geral.
            </p>
            <p>
              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para
              você, sua saúde lhe agradecerá.
            </p>
          </div>
          <div class="text" v-if="result.kit_type.tag_type === 'check-up-longevidade-saudavel'">
            <p>
              Conforme mencionado anteriormente, são muitos os benefícios de uma boa alimentação e da prática regular de
              atividades físicas.
              Mas não é demais lembrar também da <span class="bold">importância do exercício mental:</span> aquelas para
              manter a mente ativa,
              exercitar a memória, retardar sintomas ou doenças.
            </p>
            <p>
              Cada vez mais a meditação vem sendo objeto de pesquisa e estudo de vários cientistas, que descobrem e
              comprovam que ela tem um grande efeito benéfico principalmente sobre o cérebro.
            </p>
            <p>
              A prática diária da meditação traz efeitos surpreendentes, tanto para o bem-estar físico como para o
              psicológico,
              podendo ajudar a controlar a dor, o sofrimento e a ansiedade.
            </p>
            <p>
              Ainda, estudos comprovam que a prática pode ser tão eficaz quanto certos medicamentos.
            </p>
            <p>
              Além de trabalhar a mente com a meditação, também é importante incluir em sua rotina a dança,
              teatro e viagens, pois são aliados importantes na busca de uma longevidade saudável, além de reforçar
              vínculos com amigos e familiares.
            </p>
            <p>
              Seguindo nossas orientações e dicas aqui oferecidas, bem como o plano de cuidado que estruturamos para
              você, sua saúde lhe agradecerá.
            </p>
          </div>
        </div>
      </div>
    </div>
	</template>
  </div>
</template>
<script>
	import ReturnModal from '../ReturnModal/ReturnModal'

    export default {
        name: "kit-tips",
		components: { ReturnModal },
        props: {
            result: Object,
        },
        setup(props) {
            const result = props.result;
            return {result};
        },
        methods: {
            back() {
                this.$emit('back');
            },
        },
        mounted() {

        }
    }
</script>
<style scoped>
  @import "./kit-tips.scss";
  @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/KitTips/KitTips.vue